import { useState } from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { buildMarkImageBlob, downloadBlob } from "@/lib/keepsakeArtifacts";

// Opens the native share sheet with a generated keepsake image card,
// falling back to a PNG download.
export default function ShareMark({ markings, printUri, guestName, overall, className, testId = "share-mark-button" }) {
  const [busy, setBusy] = useState(false);

  const share = async () => {
    setBusy(true);
    try {
      const blob = await buildMarkImageBlob({ markings, printUri, guestName, overall });
      if (!blob) throw new Error("no blob");
      const file = new File([blob], "soma-linea-mark.png", { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: "My mark · Soma Linea" });
      } else {
        downloadBlob(blob, "soma-linea-mark.png");
        toast.success("Saved your mark ✦");
      }
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Couldn't create the share card");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={share}
      disabled={busy}
      data-testid={testId}
      className={
        className ||
        "flex w-full items-center justify-center gap-2 rounded-xl border border-parch-ink py-3 font-bold text-parch-ink hover:bg-parch-card disabled:opacity-60"
      }
    >
      <Share2 size={18} />
      {busy ? "Preparing…" : "Share my mark"}
    </button>
  );
}
